import { DateTime } from 'luxon';

import { InitialValues } from 'forms/types';

import { OccupationFormValues } from '../form/types';
import { GetOccupationQuery } from '../graphql/GetSurveyOccupation';

const decodeYear = (datetime?: string | null) =>
  datetime ? DateTime.fromISO(datetime).year : null;

const buildInitialValues = (data?: GetOccupationQuery): InitialValues<OccupationFormValues> => {
  const surveyOccupation = data?.surveyOccupation;

  return {
    annualIncomeBeforeCompany: surveyOccupation?.annualIncomeBeforeCompany,
    atLeast30HoursAWeek: surveyOccupation?.atLeast30HoursAWeek,
    becameOwnerAt: decodeYear(surveyOccupation?.becameOwnerAt),
    companyFoundedAt: decodeYear(surveyOccupation?.companyFoundedAt),
    corporateStructure: surveyOccupation?.corporateStructure,
    disabilityInsuranceSource: surveyOccupation?.disabilityInsuranceSource,
    disabilityInsuranceStatus: surveyOccupation?.disabilityInsuranceStatus,
    educationLevel: surveyOccupation?.educationLevel ?? 'high_school',
    employerPaysPremium: surveyOccupation?.employerPaysPremium,
    existingCoverage: surveyOccupation?.existingCoverage,
    governmentEmployee: surveyOccupation?.governmentEmployee,
    individualIncome: surveyOccupation?.individualIncome,
    intendToReplace: surveyOccupation?.intendToReplace,
    job: surveyOccupation?.job
      ? {
          label: surveyOccupation.job.title,
          value: surveyOccupation.job.id,
          subLabel: surveyOccupation.job.group,
        }
      : null,
    numberOfEmployees: surveyOccupation?.numberOfEmployees,
    numberOfPartners: surveyOccupation?.numberOfPartners,
    ownershipStake: surveyOccupation?.ownershipStake,
    selfEmployed: surveyOccupation?.selfEmployed,
    workFromHomePercentage: surveyOccupation?.workFromHomePercentage ?? 0,
    yearsOfExperience: surveyOccupation?.yearsOfExperience,
  };
};

export default buildInitialValues;
